/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IAssessmentsConfig, IQueuesConfig, ITasksConfig } from 'app/core/models/essette-interfaces';
import { HouseholdCasePageContext } from 'app/cm/lib/household-case-page-context';
import { getApiSetting } from 'app/shared/lib/api/api-settings';

@autoinject()
export class HouseholdCaseTasksPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected householdCaseId!: string;

    protected tasksConfig: ITasksConfig = {
        serviceRootUrl: 'cm/cases',
        targetType: 'CM.Case',
        primaryTargetType: 'CM.CaseTask',
        labelKey: 'core:task.$',
        allowDuplicates: false,
        rollupConfig: {
            serviceRootUrl: 'cm/households/cases/'
        }
    };

    protected queuesConfig: IQueuesConfig = {
        serviceRootUrl: 'cm/tasks',
        targetType: 'CM.Intervention'
    };

    protected assessmentsConfig: IAssessmentsConfig = {
        serviceRootUrl: 'cm/cases',
        targetType: 'CM.Case',
    };

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly context: HouseholdCasePageContext,
        ...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(params: { householdCaseId: string }): Promise<boolean> {
        if(!params.householdCaseId) { throw new Error('Missing or invalid householdCaseId parameter'); }

        return true;
    }

    protected async activate(params: { householdCaseId: string }): Promise<void> {
        if(this.householdCaseId !== params.householdCaseId) { this.householdCaseId = params.householdCaseId; }
        this.tasksConfig.allowDuplicates = !!getApiSetting(this.context.settings, 'tasks.$allowDuplicates');
    }

    ////****************** Events ***************************************************////

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////

}
